import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author?: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  author,
  delay = 0
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-354">
      <div className="flex gap-1 mb-4" data-id="element-355">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-[#D4AF37] fill-current" data-id="element-356" />)}
      </div>
      <p className="text-gray-700 italic mb-4 relative z-10" data-id="element-357">"{quote}"</p>
      {author && <p className="text-sm font-bold text-gray-900" data-id="element-358">— {author}</p>}
    </motion.div>;
}